/* eslint-disable react/no-unknown-property */
import React from 'react';
import { Skeleton, TextSkeleton, TypographyName } from '@doveit/bricks';
import * as styles from './GoalMetricCard.style';

export const GoalMetricCardSkeleton = () => (
  <div
    css={styles.basic}
    $isSkeleton
  >
    <div css={styles.header}>
      <div css={styles.title}>
        <div>
          <Skeleton
            width="1.5rem"
            height="1.5rem"
          />
        </div>
        <div css={styles.titleText}>
          <TextSkeleton typography={TypographyName.HEADING_4} />
        </div>
      </div>
      <div />
    </div>
    <div css={styles.details}>
      <TextSkeleton typography={TypographyName.BODY_SMALL} />
    </div>
  </div>
);

export default GoalMetricCardSkeleton;
